import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ClientesService } from '../../services/clientes.service';
import { AuthService } from '../../services/auth.service';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { LocalizationService } from '../../services/localization.service';
import { ApiResult } from '../../models/ApiResult';
import { ModelHelpers } from '../../models/ModelHelpers';
import { ClienteModel } from '../../models/ClienteModel';
import { ErrorHelper } from '../../models/ErrorHelper';
import { TasacionesService } from '../../services/tasaciones.service';


@Component({
  selector: 'app-clientes-edit',
  templateUrl: './clientes-edit.component.html',
  styleUrls: ['./clientes-edit.component.css']
})
export class ClientesEditComponent implements OnInit {

  clienteForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;

  id: number;
  isModal: boolean;
  errorMessage: String = '';

  localization: LocalizationService;
  contratosList: any;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute,
    private _ClientesService: ClientesService, private _authService: AuthService, private _router: Router,
    public dialogRef: MatDialogRef<ClientesEditComponent>,
    private _location: Location, localization: LocalizationService, private _TasacionesService: TasacionesService) {

    this.localization = localization;

    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.clienteForm = this._fb.group({
      id: 0,
      displayName: ['', Validators.required],
      group: [{ value: '', disabled: true }],
      address1: [''],
      address2: [''],
      zipCode: [''],
      state: [''],
      city: [''],
      country: ['', [Validators.required, Validators.maxLength(2)]],
      telMobile: [''],
      telHome: [''],
      email: [''],
      customerType: [0, Validators.required],
      //customerTypeName: [ '' ],
      vatNumber: ['', Validators.required],
      activo: [true],
      navNo: [''],
      contratoID: [null]
    });
  }

  esParticular(): boolean {
    return (this.clienteForm.controls.customerType.value === '0');

  }

  testCheck() {
    if (this.clienteForm.controls.customerType.value === '1') {
      console.log('1');
      /*this.clienteForm.controls.businessName.enable();*/
      //this.clienteForm.controls.displayName.enable();
      this.clienteForm.controls.group.enable();
    } else {
      console.log('0');
      /*this.clienteForm.controls.businessName.disable();*/
      //this.clienteForm.controls.displayName.disable();
      this.clienteForm.controls.group.disable();
    }
  }

  ngOnInit() {


    if (this.id > 0) {
      this.isNewElement = false;
      this.title = "Editar";
      this._ClientesService.getClienteID(this.id)
        .subscribe((resp: ClienteModel) => {
          this.clienteForm.setValue(resp);
          this.testCheck();
          console.log(resp);

        }
          , error => {
            this.errorMessage = error;
          });
    }
    else {
      this.isNewElement = true;
      this.testCheck();
    }

    this.loadCombos();

  }

  loadCombos() {
    this._TasacionesService.getContratos().subscribe(data => this.contratosList = data);
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  onSaved(value: ApiResult) {

    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }

  }

  save() {
    this.saveAsync();
  }

  async saveAsync() {
    if (!this.clienteForm.valid) {
      return;
    }

    let clienteModel = new ClienteModel();
    ModelHelpers.copyFromForm(this.clienteForm.value, clienteModel);
    let result = null;

    try {
      if (this.isNewElement) {
        result = await this._ClientesService.postCliente(clienteModel).toPromise();
      }
      else {
        result = await this._ClientesService.updateCliente(this.id, clienteModel).toPromise();
      }
      this.onSaved(result);
    }
    catch (err) {
      let errorMessage = ErrorHelper.GetClientError(err);
      this.errorMessage = errorMessage;
    }
  }

  get displayName() { return this.clienteForm.get('displayName'); }
  get address1() { return this.clienteForm.get('address1'); }
  get zipCode() { return this.clienteForm.get('zipCode'); }
  get country() { return this.clienteForm.get('country'); }
  get customerType() { return this.clienteForm.get('customerType'); }
  get vatNumber() { return this.clienteForm.get('vatNumber'); }

}
